import React from 'react';
import Loading from '@/pages/intelligence/components/Loading';
import { useIntl } from 'umi';
import './index.scss';

export default function CardStats(props: any) {
  const {
    cardStatus,
    isDropdown,
    segmentIsFullGame,
    height = 'auto',
    minHeight = 124,
    isUnitsFullGame,
    noDataMessage,
    useDom,
  } = props;
  // console.log('CardStatsCardStats', props);
  const { formatMessage } = useIntl(); // 中英切换方法
  const { isLoading, isError, isNoData, noDataTextKey = '' } = cardStatus || {};
  return (
    <div className="box" style={{ height, minHeight, color: '#444' }}>
      {isLoading ? (
        <Loading content={formatMessage({ id: 'common_loading' })} />
      ) : noDataMessage ? (
        useDom ? (
          <div
            className="dbi-nodata-message"
            dangerouslySetInnerHTML={{ __html: noDataMessage }}
          ></div>
        ) : (
          noDataMessage
        )
      ) : isDropdown ? (
        <> This game drops out of top 1000 games globally.</>
      ) : isNoData && segmentIsFullGame ? (
        <>{formatMessage({ id: 'dbi_info_fullgame_nodata' })}</>
      ) : isNoData && isUnitsFullGame ? (
        <>{formatMessage({ id: 'dbi_info_unitsfullgame_nodata' })}</>
      ) : isNoData ? (
        formatMessage({ id: noDataTextKey !== '' ? noDataTextKey : 'common_nodata' })
      ) : isError ? (
        formatMessage({ id: 'common_loading_failed' })
      ) : (
        formatMessage({ id: 'common_nodata' })
      )}
    </div>
  );
}
